/* ==========================================================================
   桌面端菜单：悬停打开，点击外部或离开 3 秒后关闭
   --------------------------------------------------------------------------
   原理：主题用 li:focus-within > .sub-menu 显示子菜单（app.css）。
         悬停时把焦点移到该项的链接上，菜单就会保持打开，
         完全复用主题的显示样式。
   防误触：没有菜单打开时，一级菜单需停下来 REST_DELAY 毫秒才打开；
         已有菜单打开时，横向移动即时切换（在浏览菜单），
         纵向穿过导航栏仍需停下来（多半是要离开）；
         下拉面板内部的二级、三级切换始终即时。
   关闭：点击外部 / 按 Esc → 立即关闭；
         鼠标离开菜单 CLOSE_DELAY 毫秒后自动关闭，期间回到菜单则取消。
         键盘 Tab 打开的菜单不自动关闭。
   性能：只在鼠标位于导航栏上时运行，每次移动仅重置一个定时器，开销可忽略。
   附加：子菜单超出屏幕右侧时，自动改为向左展开（.lei-flip）
   依赖：lei-custom.css 里的 .lei-menu-ready、.lei-hover-focus、.lei-flip 规则
   范围：仅桌面鼠标设备，手机/平板不受影响
   回滚：删除本段代码和对应 CSS 即可
   更新：2026-10 Leigh
   ========================================================================== */
(function () {
  // 只在桌面鼠标设备上启用
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  // 主题菜单容器，主题升级后如果失效，先检查这个选择器
  var nav = document.querySelector('.thb-full-menu');
  if (!nav) return;

  var REST_DELAY = 120;   // 鼠标静止多少毫秒才算"停下来"，误触多就调大，觉得慢就调小
  var CLOSE_DELAY = 3000; // 鼠标离开菜单多少毫秒后自动关闭
  var restTimer = null;
  var closeTimer = null;
  var lastX = 0, lastY = 0; // 上一次鼠标位置，用来判断移动方向

  // 告诉 CSS：JS 已接管一级菜单的打开（JS 没加载时主题原样工作）
  nav.classList.add('lei-menu-ready');

  // 二级及以下的子菜单：如果超出屏幕右侧，就改为向左展开
  function flipIfOverflow(li) {
    if (!li.parentElement.classList.contains('sub-menu')) return; // 一级菜单向下展开，不处理
    var sub = li.querySelector(':scope > .sub-menu');
    if (!sub) return;
    li.classList.remove('lei-flip'); // 先按默认方向测量
    if (sub.getBoundingClientRect().right > document.documentElement.clientWidth) {
      li.classList.add('lei-flip');
    }
  }

  // 打开鼠标所在的那一项：聚焦链接（触发主题的 :focus-within 显示），并检查方向
  function openAt(target) {
    var li = target.closest('li');
    if (!li || !nav.contains(li)) return;
    // 焦点已经在这一项里面（比如鼠标划过子菜单之间的空隙）就不动，避免误关下级菜单
    if (li.contains(document.activeElement)) return;
    var link = li.querySelector(':scope > a');
    if (!link) return;
    // 标记为"鼠标悬停触发的焦点"，CSS 据此隐藏焦点框；失焦时自动去掉标记
    link.classList.add('lei-hover-focus');
    link.addEventListener('blur', function () { link.classList.remove('lei-hover-focus'); }, { once: true });
    link.focus({ preventScroll: true });
    flipIfOverflow(li);
  }

  // 关闭菜单：让焦点离开菜单，主题的 :focus-within 随之失效
  function closeMenu() {
    if (nav.contains(document.activeElement)) document.activeElement.blur();
  }

  nav.addEventListener('mousemove', function (e) {
    var dx = Math.abs(e.clientX - lastX), dy = Math.abs(e.clientY - lastY);
    lastX = e.clientX; lastY = e.clientY;
    clearTimeout(restTimer); // 鼠标还在动 → 取消上一次的等待

    var li = e.target.closest('li');
    // 下拉菜单内部（二级、三级）→ 即时切换，用户已经在使用菜单
    if (li && li.parentElement.classList.contains('sub-menu')) { openAt(e.target); return; }
    // 已有菜单打开，且鼠标在横向移动 → 用户在浏览一级菜单，即时切换
    if (nav.contains(document.activeElement) && dx > dy) { openAt(e.target); return; }
    // 其他情况（没有菜单打开，或纵向穿过导航栏）→ 停下来才打开，路过不触发
    var target = e.target;
    restTimer = setTimeout(function () { openAt(target); }, REST_DELAY);
  });

  // 鼠标回到菜单 → 取消自动关闭，并记录进入位置（供方向判断用）
  nav.addEventListener('mouseenter', function (e) {
    clearTimeout(closeTimer);
    lastX = e.clientX; lastY = e.clientY;
  });

  // 鼠标离开菜单 → 取消等待中的打开；如果菜单是鼠标打开的，CLOSE_DELAY 后自动关闭
  nav.addEventListener('mouseleave', function () {
    clearTimeout(restTimer);
    var active = document.activeElement;
    if (nav.contains(active) && active.classList.contains('lei-hover-focus')) {
      clearTimeout(closeTimer);
      closeTimer = setTimeout(closeMenu, CLOSE_DELAY);
    }
  });

  // 按 Esc → 立即关闭
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeMenu();
  });
})();